"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const FormFieldError_1 = __importDefault(require("../../components/FormFieldError"));
const FormContext_1 = __importDefault(require("../../context/FormContext"));
const styles = require('./FormField.module.scss');
const noErrors = [];
const FormField = ({ children, className = '', errors = [], id, name, validateOnBlur = true, noMargin, }) => {
    const { setValue, errors: formValidationErrors, resetValue, commitValue, touchField, touched, } = (0, react_1.useContext)(FormContext_1.default);
    const isTouched = touched[name];
    const fieldErrors = (0, react_1.useMemo)(() => [...errors, ...(formValidationErrors[name] || [])], [
        errors,
        formValidationErrors,
        name,
    ]);
    const onChange = (0, react_1.useCallback)((value) => {
        setValue(name, value);
    }, [setValue, name]);
    const onReset = (0, react_1.useCallback)(() => {
        resetValue(name);
    }, [resetValue, name]);
    const onBlur = (0, react_1.useCallback)(() => {
        touchField(name);
    }, [touchField, name]);
    const onCommit = (0, react_1.useCallback)((value) => {
        commitValue(name, value);
    }, [commitValue, name]);
    const childrenProps = (0, react_1.useMemo)(() => ({
        errors: (isTouched && fieldErrors) || noErrors,
        onBlur,
        onChange,
        onCommit,
        onReset,
    }), [fieldErrors, isTouched, onBlur, onChange, onCommit, onReset]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.root, {
            [className]: !!className,
            [styles.noMargin]: !!noMargin,
        }), id: id },
        children && children(childrenProps),
        validateOnBlur && isTouched
            ? fieldErrors &&
                fieldErrors.map((error) => (react_1.default.createElement(FormFieldError_1.default, { key: error, typeIdPrefix: name }, error)))
            : null));
};
exports.default = (0, react_1.memo)(FormField);
//# sourceMappingURL=FormField.js.map